import React, { lazy, Suspense } from 'react';
import { LazyMotion, domAnimation } from 'framer-motion';
import { Hero } from './components/sections/Hero';
import { StickyCTA } from './components/ui/StickyCTA';

// Everything below the hero is code-split into its own chunk and loaded right
// after the initial paint — none of it is needed to render the first screen,
// so it shouldn't compete with the hero/LCP for the browser's main thread.
const TrustStats = lazy(() => import('./components/sections/TrustStats').then(mod => ({
  default: mod.TrustStats
})));
const Transformation = lazy(() => import('./components/sections/Transformation').then(mod => ({
  default: mod.Transformation
})));
const ForYou = lazy(() => import('./components/sections/ForYou').then(mod => ({
  default: mod.ForYou
})));
const WhatYouGet = lazy(() => import('./components/sections/WhatYouGet').then(mod => ({
  default: mod.WhatYouGet
})));
const InstantAccess = lazy(() => import('./components/sections/InstantAccess').then(mod => ({
  default: mod.InstantAccess
})));
const BonusesDetail = lazy(() => import('./components/sections/BonusesDetail').then(mod => ({
  default: mod.BonusesDetail
})));
const Testimonials = lazy(() => import('./components/sections/Testimonials').then(mod => ({
  default: mod.Testimonials
})));
const AboutAuthor = lazy(() => import('./components/sections/AboutAuthor').then(mod => ({
  default: mod.AboutAuthor
})));
const Pricing = lazy(() => import('./components/sections/Pricing').then(mod => ({
  default: mod.Pricing
})));
const KitUpsell = lazy(() => import('./components/sections/KitUpsell').then(mod => ({
  default: mod.KitUpsell
})));
const Guarantee = lazy(() => import('./components/sections/Guarantee').then(mod => ({
  default: mod.Guarantee
})));
const FAQ = lazy(() => import('./components/sections/FAQ').then(mod => ({
  default: mod.FAQ
})));
const FinalCTA = lazy(() => import('./components/sections/FinalCTA').then(mod => ({
  default: mod.FinalCTA
})));
const Footer = lazy(() => import('./components/sections/Footer').then(mod => ({
  default: mod.Footer
})));
export function App() {
  return <LazyMotion features={domAnimation} data-id="element-0" data-mp="3udkr489qbgg7">
      <div className="w-full min-h-full bg-bg-primary font-body text-white" data-id="element-1" data-mp="3uevrrz7vo833">
        <main data-id="element-2" data-mp="d45sc040y5kz">
          <Hero data-id="element-3" data-mp="d3wbb20yj8rf" />
          <Suspense fallback={null} data-id="element-4" data-mp="d2bhjemgvtum">
            <TrustStats data-id="element-5" data-mp="85bd1859mz5m" />
            <Transformation data-id="element-6" data-mp="864atjm8yebm" />
            <ForYou data-id="element-7" data-mp="83qhbf77ta66" />
            <WhatYouGet data-id="element-8" data-mp="3gl4qfe4avuig" />
            <InstantAccess data-id="element-9" data-mp="3gmfwjkl7xecq" />
            <BonusesDetail data-id="element-10" data-mp="3glo0k8nplelx" />
            <Testimonials data-id="element-11" data-mp="3bmbevr8kqdkx" />
            <AboutAuthor data-id="element-12" data-mp="3bn2ys4st6mvd" />
            <Pricing data-id="element-13" data-mp="3bnuurgqbimm6" />
            <KitUpsell data-id="element-14" data-mp="3bk718hkvi07g" />
            <Guarantee data-id="element-15" data-mp="3qaxrhl6tgr8g" />
            <FAQ data-id="element-16" data-mp="3qbfud0nzi3pc" />
            <FinalCTA data-id="element-17" data-mp="3qbzf0p50r672" />
          </Suspense>
        </main>
        <Suspense fallback={null} data-id="element-18" data-mp="3lkr41oo1jcrs">
          <Footer data-id="element-19" data-mp="3ljpigq9ef7vt" />
        </Suspense>
        <StickyCTA data-id="element-20" data-mp="3limrkic2t5fw" />
      </div>
    </LazyMotion>;
}